import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import Onefire1 from '../assets/images/onfire1.png'
import Onefire2 from '../assets/images/onfire2.png'
import Onefire3 from '../assets/images/onfire3.png'
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';


// import required modules
import { FreeMode, Autoplay } from 'swiper/modules';


export default function Onfire() {
  const swiperRef = useRef<any>(null); // Create a ref for the swiper instance
  const [activeButton, setActiveButton] = useState<string>('');


  const goNext = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
      setActiveButton('next');
    }
  };

  const goPrev = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
      setActiveButton('prev');
    }
  };

  return (
    <>
      <div className="row d-flex align-items-center">
        <div className="col-7 castom_m-y">
          <h1 className='mainTital d-flex justify-content-start align-items-center'>On Fire 🔥 </h1>
        </div>
        <div className="col-5 text-end d-flex justify-content-end align-items-center castom_m-y">
          <h3 className='sumTital me-1'>
            All
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" style={{ marginLeft: 1 }}>
              <path d="M7.84443 6.73748L4.36392 10.2179L5.35833 11.2123L9.83325 6.73748L5.35833 2.26256L4.36392 3.25697L7.84443 6.73748Z" fill="#CCCCCC" />
            </svg>
          </h3>
          <button className={`custom-prev ${activeButton === 'prev' ? 'sportActive' : ''} me-1`}
            onClick={goPrev}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
              <path d="M7.20779 6.68305L10.9369 10.4121L9.87146 11.4775L5.0769 6.68305L9.87146 1.88849L10.9369 2.95393L7.20779 6.68305Z" fill="#CCCCCC" />
            </svg>
          </button>
          <button className={`custom-next ${activeButton === 'next' ? 'sportActive' : ''}`}
            onClick={goNext}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
              <path d="M7.94602 6.68305L4.2169 10.4121L5.28234 11.4775L10.0769 6.68305L5.28235 1.88849L4.2169 2.95393L7.94602 6.68305Z" fill="#CCCCCC" />
            </svg>
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Swiper
            ref={swiperRef}
            modules={[Autoplay, FreeMode]}
            autoplay={false}
            loop={false}
            // speed={300}
            slidesPerView={2}
            spaceBetween={12}
            freeMode={true}
            breakpoints={{
              768: {
                slidesPerView: 2,  
              },
              1024: {
                slidesPerView: 4, 
              },
            }}
          >
            <SwiperSlide>
              <div className='casino'>
                <img src='https://images.unsplash.com/photo-1517232115160-ff93364542dd?q=80&w=2146&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src={Onefire2} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src={Onefire3} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src='https://images.unsplash.com/photo-1517232115160-ff93364542dd?q=80&w=2146&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src={Onefire2} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src='https://images.unsplash.com/photo-1517232115160-ff93364542dd?q=80&w=2146&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src={Onefire2} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src={Onefire3} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src='https://images.unsplash.com/photo-1517232115160-ff93364542dd?q=80&w=2146&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src={Onefire2} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src='https://images.unsplash.com/photo-1517232115160-ff93364542dd?q=80&w=2146&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src={Onefire2} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src={Onefire3} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src='https://images.unsplash.com/photo-1517232115160-ff93364542dd?q=80&w=2146&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='casino'>
                <img src={Onefire2} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  );
}
